export const SCRIPT_SRC =
  '//translate.google.com/translate_a/element.js?cb=initGoogleTranslate';
export const EL_SCRIPT_SRC =
  '//translate.google.com/translate_a/element.js?cb=initGoogleTranslateElementary';

export const SCRIPT_SELECTORS = [
  '#goog-gt-tt',
  '.goog-te-spinner-pos',
  'iframe.goog-te-menu-frame.skiptranslate',
  'div.skiptranslate',
];

export const LANGUAGE_OPTIONS = [
  { label: 'Albanian', value: 'sq' },
  { label: 'Amharic', value: 'am' },
  { label: 'Arabic', value: 'ar' },
  { label: 'Armenian', value: 'hy' },
  { label: 'Bengali', value: 'bn' },
  { label: 'Bosnian', value: 'bs' },
  { label: 'Bulgarian', value: 'bg' },
  { label: 'Burmese', value: 'my' },
  { label: 'Chinese (Simplified)', value: 'zh-CN' },
  { label: 'Chinese (Traditional)', value: 'zh-TW' },
  { label: 'Dutch', value: 'nl' },
  { label: 'English', value: 'en' },
  { label: 'Filipino', value: 'tl' },
  { label: 'French', value: 'fr' },
  { label: 'German', value: 'de' },
  { label: 'Greek', value: 'el' },
  { label: 'Gujarati', value: 'gu' },
  { label: 'Haitian Creole', value: 'ht' },
  { label: 'Hebrew', value: 'iw' },
  { label: 'Hindi', value: 'hi' },
  { label: 'Hmong', value: 'hmn' },
  { label: 'Igbo', value: 'ig' },
  { label: 'Ilocano', value: 'ilo' },
  { label: 'Italian', value: 'it' },
  { label: 'Japanese', value: 'ja' },
  { label: 'Khmer', value: 'km' },
  { label: 'Korean', value: 'ko' },
  /* cspell:disable-next-line */
  { label: 'Kinyarwanda', value: 'rw' },
  { label: 'Lao', value: 'lo' },
  { label: 'Malayalam', value: 'ml' },
  { label: 'Mongolian', value: 'mn' },
  { label: 'Nepali', value: 'ne' },
  { label: 'Pashto', value: 'ps' },
  { label: 'Persian', value: 'fa' },
  { label: 'Polish', value: 'pl' },
  { label: 'Portuguese', value: 'pt' },
  { label: 'Portuguese (Portugal)', value: 'pt-PT' },
  { label: 'Punjabi', value: 'pa' },
  { label: 'Romanian', value: 'ro' },
  { label: 'Russian', value: 'ru' },
  { label: 'Serbian', value: 'sr' },
  { label: 'Sindhi', value: 'sd' },
  { label: 'Somali', value: 'so' },
  { label: 'Spanish', value: 'es' },
  { label: 'Swahili', value: 'sw' },
  { label: 'Tamil', value: 'ta' },
  { label: 'Telugu', value: 'te' },
  { label: 'Thai', value: 'th' },
  { label: 'Turkish', value: 'tr' },
  { label: 'Ukrainian', value: 'uk' },
  { label: 'Urdu', value: 'ur' },
  { label: 'Vietnamese', value: 'vi' },
  { label: 'Yoruba', value: 'yo' },
];

export const EL_LANGUAGE_OPTIONS = [
  { label: 'English', value: 'en' },
  { label: 'Spanish', value: 'es' },
];

export const INITIAL_LANGUAGE = { label: 'English', value: 'en' };
export const DEFAULT_LANGUAGE_ENGLISH = 'en';
export const DEFAULT_ENGLISH_GOOGLE_VALUE = '/en/en';
// Add values for languages where we have backend translations (ex. ['en', 'es', 'de'])
export const SUPPORTED_HUMAN_LANGUAGES = [];
export const GOOGLE_TRANSLATE_COOKIE_KEY = 'googtrans';
export const GOOGLE_TRANSLATE_COOKIE_OPTIONS = {
  path: '/',
  expires: 0,
};
export const GOOGLE_TRANSLATE_COOKIE_DOMAINS = [
  window.location.hostname,
  '.schoolinks.com',
];
